import { render } from "./example-company-menu.vue?vue&type=template&id=2d80963a"
import script from "./example-company-menu.vue?vue&type=script&lang=js"
export * from "./example-company-menu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/admin/common/example-company-menu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d80963a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d80963a', __exports__)) {
    api.reload('2d80963a', __exports__)
  }
  
  module.hot.accept("./example-company-menu.vue?vue&type=template&id=2d80963a", () => {
    api.rerender('2d80963a', render)
  })

}


export default __exports__